export default __webpack_public_path__ + "static/media/contemporaryV2-mobile.6513c006.jpg";